/**
 * Created by kubla on 01/05/17.
 */
import Constants from '../js/constants'

export function ruoloLega(ruolo) {
  return Constants.RUOLI_LEGA[ruolo]
}

export function maxOfferta(lega, residui, ncalciatori) {
  // illimitati, un massimo di
  if (lega.nRuoli.op == "illimitati" || lega.nRuoli.op == "<=") {
    return residui;
  }
  // esattamente, almeno
  let ncr = lega.nRuoli.nP + lega.nRuoli.nD + lega.nRuoli.nC + lega.nRuoli.nA;
  let min_offerta = Constants.OFFERTA.MINIMA;
  return Math.min(residui, parseFloat(residui - (ncr - ncalciatori) * min_offerta + min_offerta));
}

export function minOfferta(base_asta, calciatore) {
  if (base_asta == Constants.BASE_ASTA.QUOTAZIONE && calciatore)
    return parseFloat(calciatore.quotazione)
  return parseFloat(base_asta);
}

// not used perchè l'ho spostato come prop in asta_squadre
// export function isRosaCompleta(squadra, asta_info, calciatori) {
//   if (!squadra) return false;
//   if (asta_info.lega.nRuoli.op == "illimitati" ||
//     asta_info.lega.nRuoli.op == ">=") {
//     // illimintati o almeno
//     return false;
//   } else {
//     // esattamente o un massimo di
//     // c'è almeno un ruolo che non è ancora completo?
//     for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
//       const ruolo_id = ruolo.ruolo_id;
//       const isRuoloCompleto = this.isRuoloCompleto(ruolo_id, squadra, asta_info, calciatori)
//       if (isRuoloCompleto == false) return false
//     }
//     return true
//   }
// }

// export function isRuoloCompleto_old(ruolo_id, squadra, asta_info, calciatori) {
//   if (!ruolo_id) return false;
//   if (!squadra) return false;
//   if (asta_info.lega.nRuoli.op == "illimitati" ||
//     asta_info.lega.nRuoli.op == ">=") {
//     // illimintati o almeno
//     return false;
//   } else {
//     // esattamente o un massimo di
//     let output = false;
//     let counter = 0;
//     _.each(squadra.calciatori, (value, calciatore_id) => {
//       let ID_Ruolo = calciatori[calciatore_id].ID_Ruolo
//       if (ID_Ruolo == ruolo_id) counter++
//     });
//     const ruolo_n = Constants.RUOLI_NEW[ruolo_id].n;
//     if (counter >= parseFloat(asta_info.lega.nRuoli[ruolo_n])) output = true
//     return output
//   }
// }

export function isRuoloCompleto(ruolo_id, nAcquistiRuolo, asta_info) {
  if (!ruolo_id) return false;
  if (asta_info.lega.nRuoli.op == "illimitati" ||
    asta_info.lega.nRuoli.op == ">=") {
    // illimintati o almeno
    return false;
  } else {
    // esattamente o un massimo di
    let output = false;
    const nRuoli = asta_info.lega.nRuoli[Constants.RUOLI_NEW[ruolo_id].n];
    if (nAcquistiRuolo >= parseFloat(nRuoli)) output = true
    return output
  }
}

export function roundCompletato(offerte, migliore_offerta, asta_mode, asta_round) {
  ////// aggiunto da diego
  if (asta_mode == Constants.ASTA_MODE.BUSTA_CHIUSA) {
    if (
      asta_round.step == null ||
      asta_round.step.type === Constants.ROUND_STEP.OFFERTE
    ) {
      return false;
    }
  }
  ////////
  let _offerte = _.values(offerte);
  return _.size(_offerte) > 0 && _offerte.every(function(value) {
    return value >= 0;
  }) && _.sum(_offerte) == migliore_offerta;
}

export function offerteCompletate(offerte) {
  let _offerte = _.values(offerte);
  return _.size(_offerte) > 0 && _offerte.every(function(value) {
    return value >= 0;
  });
}

export function findNextSquadraIdAsChooser(asta_choosers, chooserCorrente) {
  return this.findNextSquadraId(asta_choosers, chooserCorrente, (squadraChooser) => { return squadraChooser.canBeChooser });
}

// findNextSquadraIdAsChooser(chooserCorrente) {
//   let asta_choosers = store.getters.asta_choosers;
//   let choosers = Utils.rotateArray(asta_choosers, chooserCorrente);
//   return _.head(choosers) || null;
// }

export function findNextSquadraId(squadre_array, current_squadra_id, func) {

  const startIndex = squadre_array.findIndex(item => item.id == current_squadra_id);

  if (startIndex === -1) {
    // If current_squadra_id is not found, return the first element that satisfies func
    const firstSuitableSquadra = squadre_array.find(func);
    return (firstSuitableSquadra) ? firstSuitableSquadra.id : null;
  }

  const length = squadre_array.length;

  for (let i = 1; i <= length; i++) { // only 1 loop => avoid infinite loop
    const nextIndex = (startIndex + i) % length; // Circular indexing
    const nextSquadra = squadre_array[nextIndex];
    if (func(nextSquadra)) {
      return nextSquadra.id;
    }
  }
  return null; // Return null if no matching is found
}

// export function calcoloOfferta(asta, squadra, calciatore, offerta_corrente) {
//   let offerta = null;

//   // calciatore !== null all'inizio del round
//   if (calciatore !== null) {
//     if (asta.lega.nRuoli.op !== "illimitati" && squadra.acquisti[calciatore.ID_Ruolo] >= asta.lega.nRuoli[ruoloLega(calciatore.ID_Ruolo)]) {
//       offerta = Constants.OFFERTA.PASSO;
//     } else if (asta.lega.limitRosaPerClub.perClubPerRuolo.active == 1 && squadra.acquistiPerClub[calciatore.ID_Ruolo + "_" + calciatore.ID_Club] >= parseInt(asta.lega.limitRosaPerClub.perClubPerRuolo.valore)) {
//       offerta = Constants.OFFERTA.PASSO;
//     } else {
//       offerta = Constants.OFFERTA.INIT;
//     }
//   }

//   if (squadra.max_offerta < offerta_corrente) {
//     offerta = Constants.OFFERTA.PASSO;
//   }

//   return offerta;
// }


export function canJoinRound(regole_lega, squadra, calciatore, crediti_min) {
  if (regole_lega.nRuoli.op == "<=" || regole_lega.nRuoli.op == "=") {
    if (squadra.acquisti[calciatore.ID_Ruolo] >= regole_lega.nRuoli[ruoloLega(calciatore.ID_Ruolo)]) {
      return false;
    }
  }
  if (regole_lega.limitRosaPerClub &&
    regole_lega.limitRosaPerClub.perClubPerRuolo &&
    regole_lega.limitRosaPerClub.perClubPerRuolo.active == 1 &&
    squadra.acquistiPerClub[calciatore.ID_Ruolo + "_" + calciatore.ID_Club] >= parseInt(regole_lega.limitRosaPerClub.perClubPerRuolo.valore)) {
    return false;
  }
  if (squadra.max_offerta < crediti_min) {
    return false;
  }
  return true;
}

export function canRilanciare(squadra, crediti) {
  if (squadra.max_offerta < crediti) {
    return false;
  }
  return true;
}

export function canOffrire(squadra, crediti) {
  if (squadra.max_offerta < crediti) {
    return false;
  }
  return true;
}

export function getUniquePresences(connections) {
  let output = []
  for (let [key, conn] of Object.entries(connections)) {
    if (!output.includes(conn.presence)) {
      output.push(conn.presence)
    }
  }
  return output
}

export function isEmpty(obj) {
  if (obj && Object.keys(obj).length === 0) {
    return true;
  } else {
    return false;
  }
}

export function offertePiuAlte(offerte) {
  let output = []
  let oVincente = null
  _.forOwn(offerte, function(o, sq_id) {
    if (oVincente == null || o > oVincente) {
      oVincente = o
      output = []
      output.push({
        squadra_id: sq_id,
        offerta: o,
      })
    } else if (o == oVincente) {
      output.push({
        squadra_id: sq_id,
        offerta: o,
      })
    }
  });
  return output
}

// ritorna oggetto se c'è un vincitore unico
// Assegnabile si intende un'offerta tale che si possa assegnare il calciatore
// ritorna false altrimenti
export function vincenteUnicoAssegnabile(offerte) {
  //let offertePiuAlte = offertePiuAlte(offerte)
  /////////////////////////////////////////////
  let offertePiuAlte = []
  let oVincente = null
  _.forOwn(offerte, function(o, sq_id) {
    // console.log('--- sq_id', sq_id)
    // console.log('--- o', o)
    // console.log('--- oVincente', oVincente)
    if (oVincente == null || o > oVincente) {
      // console.log('resetta array')
      oVincente = o
      offertePiuAlte = []
      offertePiuAlte.push({
        squadra_id: sq_id,
        offerta: o,
      })
    } else if (o == oVincente) {
      // console.log('push array')
      offertePiuAlte.push({
        squadra_id: sq_id,
        offerta: o,
      })
    }
  });
  //////////////////////////////////////
  // console.log(offertePiuAlte)
  // console.log(offertePiuAlte.length)
  if (offertePiuAlte.length == 1 && offertePiuAlte[0].offerta >= Constants.OFFERTA.MINIMA) {
    // console.log(offertePiuAlte[0])
    return offertePiuAlte[0]
  }
  return false
}

export function console_log(myVar) {

  console.log(`Type: ${typeof myVar}`);

  if (typeof myVar === 'object') {
    for (const key in myVar) {
      if (myVar.hasOwnProperty(key)) {
        console.log(`Key: ${key}, Type: ${typeof key}, Value Type: ${typeof myVar[key]}`);
        if (typeof myVar[key] === 'object') {
          this.console_log(myVar[key])
        }
      }
    }
  }
}